import React from "react";
import SectionView from "./SectionView";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import styled from "styled-components";

interface ActionSectionProps {
    title: string;
    prompt: string;
    action: () => void;
}

const buttonTheme = createMuiTheme({
    overrides: {
        MuiButton: {
            outlinedPrimary: {
                color: '#046A38',
                borderColor: '#046A38',
                borderWidth: '2px',
                '&:hover':{
                    borderColor:  '#046A38',
                    borderWidth: '2px',
                }
            }
        }
    }
});

const ActionButton = styled(Button)`
  left: 50%;
  transform: translate(-50%, 0);
`;

export const ActionSection = (props: ActionSectionProps) => {
    const {title, prompt, action} = props;
    return(
        <SectionView>
            <ListItem>
                <Grid
                    container

                >
                    <Grid
                        item
                        xs={12}
                    >
                    {prompt &&
                        <Typography
                            paragraph
                            align={'center'}
                        >
                            {prompt}
                        </Typography>
                    }
                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        <ThemeProvider theme={buttonTheme}>
                            <ActionButton
                                variant={'outlined'}
                                onClick={action}
                                color={'primary'}
                            >
                                {title}
                            </ActionButton>
                        </ThemeProvider>
                    </Grid>
                </Grid>
            </ListItem>
        </SectionView>
    );
};